'use client'

import { ThemeProvider } from 'next-themes'
import { SupabaseAuthProvider } from '@/components/providers/supabase-auth-provider'
import { ErrorBoundary } from '@/components/error-boundary'

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <ErrorBoundary>
      <ThemeProvider
        attribute="class"
        defaultTheme="dark"
        enableSystem
        disableTransitionOnChange
      >
        <SupabaseAuthProvider>
          {children}
        </SupabaseAuthProvider>
      </ThemeProvider>
    </ErrorBoundary>
  )
} 